import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { AttachmentModel } from '../model/attachment.model';

@Injectable()
export class AttachmentService {
    
  path = '/attachment';

  constructor(private baseService: BaseService) { }

  create(model: any) {
    return this.baseService.post(this.path, '/create', model);
  }

  save(record: AttachmentModel | FormData) {
    if (record instanceof AttachmentModel && record.id) {
      return this.put(record);
    } else if(record instanceof FormData){
      return this.post(record);
    }
  }

  post(formData: FormData) {
    return this.baseService.post(this.path, '/', formData);
  }

  put(record: AttachmentModel) {
    return this.baseService.put(this.path, '/', record);
  }

  delete(id: number){
    return this.baseService.delete(this.path, '/' + id);
  }


}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/attachment.service.ts